import React from 'react';
import { Menu } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import NotificationsBell from './NotificationsBell.jsx';
import RefreshButton from './RefreshButton.jsx';
import { useAuth } from '../contexts/AuthContext.jsx';
import { useData } from '../contexts/DataContext.jsx';
import { useAvisoAniversario } from '../utils/useAvisoAniversario.js';

const titles = {
  '/gestao/dashboard': 'Dashboard',
  '/gestao/inteligencia': 'Inteligência',
  '/gestao/unidades': 'Unidades',
  '/gestao/profissionais': 'Profissionais',
  '/gestao/lancamento': 'Lançamento de Dados',
  '/gestao/relatorios': 'Relatórios',
  '/gestao/servicos': 'Serviços & Pacotes',
  '/gestao/metas': 'Meta x Realizado',
  '/gestao/radar': 'Radar de Clientes',
  '/gestao/dna-360': 'DNA 360',
  '/gestao/candidatos': 'Candidatos',
  '/gestao/crm-sofia': 'CRM da Sofia',
  '/gestao/meta-realizado': 'Meta x Realizado',
  '/gestao/ranking': 'Ranking',
  '/gestao/configuracoes': 'Configurações',
  '/gestao/financeiro': 'Financeiro',
  '/gestao/auditoria': 'Auditoria de Acesso',
  '/gestao/usuarios': 'Usuários e Acessos',
  '/gestao/atendimento': 'Atendimento',
  '/gestao/avaliacoes': 'Avaliações dos Clientes',
  '/gestao/integracoes': 'Integrações',
  '/gestao/meu-desempenho': 'Meu Desempenho',
  '/gestao/agenda': 'Agenda',
  '/gestao/clientes': 'Clientes',
  '/gestao/estoque': 'Estoque',
  '/gestao/desafios': 'Desafios',
  '/gestao/engajamento': 'Engajamento',
  '/gestao/duelos': 'Duelos da Semana',
  '/gestao/ranking-unidade': 'Ranking da Unidade',
  '/gestao/bater-ponto': 'Bater Ponto',
  '/gestao/meu-ponto': 'Meu Ponto',
  '/gestao/aniversarios': 'Aniversários',
  '/gestao/minhas-conquistas': 'Minhas Conquistas',
  '/gestao/banco-horas': 'Banco de Horas',
  '/gestao/wrapped': 'Seu Mês',
  '/gestao/manual-recepcao': 'Manual da Recepção',
  '/gestao/minhas-conquistas': 'Minhas Conquistas',
};

export default function Header({ onMenuClick }) {
  const location = useLocation();
  const { user } = useAuth();
  const title = titles[location.pathname] || '';
  const showBell = user?.role !== 'admin' && !!user?.professionalId;
  // 16/10/2026: ponto vermelho no menu do celular enquanto houver aniversário
  // hoje que a pessoa ainda não viu (a pílula fica dentro da gaveta).
  const dataCtx = useData();
  const avisoAniv = useAvisoAniversario({ professionals: dataCtx?.professionals, userId: user?.id });

  return (
    <header className="bg-[#0F1B2D] border-b border-white/8 px-4 md:px-6 h-14 flex items-center justify-between sticky top-0 z-10 backdrop-blur-md">
      <div className="flex items-center gap-3">
        <button
          onClick={onMenuClick}
          className="relative md:hidden text-[#8C9CB5] hover:text-[#E9EEF5] transition-all duration-180 ease-fk w-10 h-10 -ml-2 flex items-center justify-center rounded-md hover:bg-white/5 active:scale-[0.95]"
        >
          <Menu size={20} strokeWidth={1.75} />
          {avisoAniv.pendente && (
            <span className="absolute top-2 right-2 w-2 h-2 rounded-full bg-danger" title="Aniversário hoje">
              <span className="sr-only">Aniversário hoje</span>
            </span>
          )}
        </button>
        {title && (
          <h1 className="text-white font-semibold text-[13px] tracking-tight">{title}</h1>
        )}
      </div>
      <div className="flex items-center gap-1.5">
        <RefreshButton />
        {showBell && <NotificationsBell />}
      </div>
    </header>
  );
}
